/**
 * Plantillas predefinidas de ERPs para facturas recibidas. Vacío al inicio:
 * cada asesoría creará las suyas conforme le lleguen distintos formatos.
 */
import type { ReceivedColumnMap, ReceivedDefaults } from "@/lib/receivedInvoiceMapping";

export interface ReceivedMappingPreset {
  id: string;
  label: string;
  description: string;
  sheet_index: number;
  header_row: number;
  column_map: ReceivedColumnMap;
  defaults: ReceivedDefaults;
  headerSignature: string[];
}

export const RECEIVED_PRESETS: ReceivedMappingPreset[] = [
  {
    id: "generic-compact-recibidas",
    label: "ERP genérico — recibidas (compact)",
    description:
      "Cabecera: N. Fac. | F. Recep. | codigo proveedor | ... | CIF | Nombre | Base | % Iva | Cuota Iva | % Rec | Recargo | %Ret | Reten. | Total",
    sheet_index: 0,
    header_row: 1,
    column_map: {
      invoiceNumber: "A",
      invoiceDate: "B",
      accountingDate: "B",
      supplierAccount: "C",
      expenseAccount: "F",
      supplierTaxId: "G",
      supplierName: "H",
      taxableBase: "I",
      vatRate: "J",
      vatAmount: "K",
      surchargeRate: "L",
      surchargeAmount: "M",
      irpfRate: "N",
      irpfAmount: "O",
      totalAmount: "P",
    },
    defaults: {
      dateFormat: "auto",
      decimalSeparator: "auto",
      defaultOperationType: "interior",
    },
    headerSignature: [
      "n fac",
      "f recep",
      "codigo proveedor",
      "cif",
      "base",
      "cuota iva",
      "total",
    ],
  },
];

const normalize = (s: string): string =>
  (s || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[º°ª]/g, "")
    .replace(/[^a-z0-9 ]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();

export const detectReceivedPresetFromHeaders = (headers: string[]): ReceivedMappingPreset | null => {
  const norm = headers.map(normalize);
  for (const p of RECEIVED_PRESETS) {
    const ok = p.headerSignature.every((needle) =>
      norm.some((h) => h.includes(normalize(needle))),
    );
    if (ok) return p;
  }
  return null;
};
